export default "__VITE_ASSET__b2eb2b27__"